import 'regenerator-runtime/runtime';
import Alpine from 'alpinejs';
import focus from '@alpinejs/focus';
window.Alpine = Alpine;
Alpine.plugin(focus);
Drupal.behaviors.alpinejs = {
  isStarted: false,
  attach: function attach() {
    if (Drupal.behaviors.alpinejs.isStarted === false) {
      Alpine.start();
      Drupal.behaviors.alpinejs.isStarted = true;
    }
  }
};